import clsx from 'clsx';
import React from 'react';

import { TextButton } from '@components/Button/variants';
import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';
import IconArrow from '@components/Images/Rebranding/IconArrow';
import useEventTracking from '@hooks/useEventTracking';
import { article_path, briefing_path } from '@routes';
import { ClickTarget, ContentType, TrackingLocation, click } from '@tracking';
import { FeedContentType } from '@utils/enums';

import styles from './styles.module.scss';

interface RelatedItemsProps {
  relatedItems: ArticleOrBriefing[];
}

const ContinuedReadingContainer = ({ relatedItems }: RelatedItemsProps) => {
  const { trackEvent } = useEventTracking({ location: TrackingLocation.ContinuedReading });

  return (
    <aside
      className={clsx(
        styles.ContinueReadingContainer,
        '-mr-16 mt-64 bg-grayscale-beige pb-48 pl-48 pt-32 xs:-mr-16 sm:-mr-28 md:-mr-28 lg:-mr-[42px] xl:-mr-90'
      )}
    >
      <div className="max-w-[783px] pr-24">
        <div className="border-0 border-b border-solid border-grayscale-gray pb-16 font-suisse-intl-mono text-body-takeaway text-grayscale-charcoal">
          Continued reading
        </div>
        {relatedItems.map(({ id, slug, title, type }) => (
          <div className="flex items-start pt-16" key={slug}>
            <div className="pt-2">
              <IconArrow className="mr-16 h-20 w-20 rotate-180" />
            </div>
            <TextButton
              as="link"
              href={type === FeedContentType.Article ? article_path(slug) : briefing_path(slug)}
              className="!font-suisse-neue !text-body-lg no-underline"
              onClickCapture={() =>
                trackEvent(
                  click({
                    clickTarget: ClickTarget.Headline,
                    contentId: id,
                    clickText: title,
                    contentType:
                      type === FeedContentType.Article ? ContentType.Article : ContentType.Briefing,
                  })
                )
              }
            >
              {title}
            </TextButton>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default ContinuedReadingContainer;
